import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axiosInstance from "../../api/axiosInstance";

export default function UserList() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch users
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await axiosInstance.get("/admin/user-list");
        setUsers(res.data.users || []);
      } catch (err) {
        console.error("Failed to fetch users:", err);
        toast.error("⚠️ Failed to fetch users.");
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, []);

  const handleRoleToggle = async (phone, hasDoctorRole) => {
    try {
      const endpoint = hasDoctorRole
        ? `/admin/remove-doctor-role/${phone}`
        : `/admin/add-doctor-role/${phone}`;

      const res = await axiosInstance.post(endpoint);
      toast.success(res.data.message || "Role updated successfully");

      setUsers((prev) =>
        prev.map((user) =>
          user.phone === phone
            ? { ...user, roles: res.data.roles }
            : user
        )
      );
    } catch (err) {
      console.error("Failed to update role:", err);
      toast.error("⚠️ Failed to update role.");
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen text-gray-500">
        Loading users...
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-6xl mx-auto bg-white shadow-md rounded-xl p-6">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">
          👥 User Management
        </h2>

        {Array.isArray(users) && users.length > 0 ? (
          <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-200 rounded-lg overflow-hidden">
              <thead className="bg-indigo-100">
                <tr>
                  <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">Profile</th>
                  <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">Name</th>
                  <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">Phone</th>
                  <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">Roles</th>
                  <th className="px-6 py-3 text-center text-sm font-semibold text-gray-700">Action</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {users.map((user) => {
                  const hasDoctorRole = user.roles.includes("doctor");
                  return (
                    <tr key={user.phone} className="hover:bg-gray-50">
                      <td className="px-6 py-3">
                        <img
                          src={user.profile}
                          alt={user.name}
                          className="w-12 h-12 rounded-full object-cover border"
                        />
                      </td>
                      <td className="px-6 py-3 text-gray-800">{user.name || "—"}</td>
                      <td className="px-6 py-3 text-gray-600">{user.phone}</td>
                      <td className="px-6 py-3 text-gray-600">
                        {user.roles.join(", ")}
                      </td>
                      <td className="px-6 py-3 text-center">
                        <button
                          onClick={() => handleRoleToggle(user.phone, hasDoctorRole)}
                          className={`px-4 py-2 rounded-md text-sm font-medium ${hasDoctorRole
                              ? "bg-red-100 text-red-700 hover:bg-red-200"
                              : "bg-green-100 text-green-700 hover:bg-green-200"
                            }`}
                        >
                          {hasDoctorRole ? "Remove Doctor role" : "Add Doctor role"}
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="text-gray-500 text-center py-6">No users found.</p>
        )}
      </div>
    </div>
  );
}
